import { useQuery } from '@tanstack/react-query';
import { GetMyRefferals, UserWalletAuthService } from 'services/openapi';
import { AuthQueryKeys } from './constants';

export const useGetMyReferraQuery = () => {
  const queryKey = [AuthQueryKeys.GET_MY_REFERRAL];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetMyRefferals, Error>({
    queryKey,
    queryFn: () => UserWalletAuthService.authControllerGetMyReferrals(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
